export function getdata() {
 	var obj ={
 		headlist: [{
 				name: "待开数据"
 			},
 			{
 				name: "结果回写"
 			}
 		]
 	}
 	return obj
 }
